import { StoreBcInfo } from '@tt4b/ttam-enums';

/**
 * 用户对 Shop 的权限
 */
export const UserRoleOfStore = {
  admin: 1, // 管理员
  advertise: 2, // 推广
};

/**
 * shop 校验结果
 */
export const shopStateMap = {
  available: 0,
  unavailable: -1,
  notbindTTAdmin: -2, // 3p store未绑定TT & admin权限
  notbindTTNotAdmin: -3, // 3p store未绑定TT & 非admin权限
};

/**
 * 3P店铺绑定TT状态
 */
export const StoreBindingTTStatus = {
  binded: 1, // 已绑定
  unbinded: 2, // 未绑定
};

export interface DisplayShopListItem {
  id: string;
  name: string;
  bc_id: string;
  type: number;
  catalog_id: number;
  country: string[];
  bc_info: StoreBcInfo;
  platform_id: string;
  thumbnail_url: string;
  isShowPopoverDescribe: boolean;
  isStoreUnbindTTDisabled: boolean;
  disabled: boolean;
  onlyId: string;
  tiktok_binding_status_3p: number;
  shop_user_role: number;
  available_quota: number;
  isAssetLimit: boolean;
}
